<template>
  <PublicView>
    <main v-if="product" style="text-align: left">
      <div class="shop-item-single py-120">
        <div class="container">
          <div class="row">
            <div class="col-lg-5">
              <div class="item-gallery mb-5">
                <div
                  class="flex-viewport"
                  style="overflow: hidden; position: relative"
                >
                  <img :src="previewImg" alt="" />
                </div>
                <div
                  class="flexslider-thumbnails pt-3"
                  v-if="product.images.length > 1"
                >
                  <swiper
                    @swiper="setThumbsSwiper"
                    :spaceBetween="10"
                    :slidesPerView="'auto'"
                    :freeMode="true"
                    :watchSlidesProgress="true"
                    :modules="modules"
                    class="mySwiper"
                  >
                    <swiper-slide
                      v-for="i in product.images"
                      :key="i"
                      v-on:click="previewImg = i"
                    >
                      <img :src="i" />
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single-item-info" style="text-align: left">
                <h4 class="single-item-title">{{ product.name }}</h4>
                <div class="single-item-price">
                  <h4>
                    <span v-if="price != -1">{{ numberFormat(price) }}</span>
                    <span v-if="price == -1">(Liên hệ)</span>
                  </h4>
                </div>
                <p class="mb-4">
                  {{ product.shortDescription }}
                </p>

                <hr />
                <div class="single-item-share">
                  <span>Share:</span>
                  <a href="#"><i class="fab fa-facebook-f"></i></a>
                  <a href="#"><i class="fab fa-twitter"></i></a>
                  <a href="#"><i class="fab fa-instagram"></i></a>
                  <a href="#"><i class="fab fa-linkedin-in"></i></a>
                  <a href="#"><i class="fab fa-pinterest-p"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="single-item-details">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  class="nav-link"
                  id="nav-tab1"
                  data-bs-toggle="tab"
                  data-bs-target="#tab1"
                  type="button"
                  role="tab"
                  v-bind:class="{'active': tab == 0}"
                  aria-controls="tab1"
                  aria-selected="true"
                  v-on:click="tab = 0"
                >
                  Mô tả
                </button>
                <button
                  class="nav-link"
                  id="nav-tab1"
                  v-on:click="tab = 1"
                  v-bind:class="{'active': tab == 1}"
                >
                  Chương trình học
                </button>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show"
                  v-bind:class="{'active': tab == 0}"
                id="tab1"
                role="tabpanel"
                aria-labelledby="nav-tab1"
                v-if="tab == 0">
                <div
                  class="single-item-desc"
                  v-html="product.description"></div>
              </div>
              <div
                class="tab-pane fade show"
                  v-bind:class="{'active': tab == 1}"
                id="tab-content"
                role="tabpanel"
                aria-labelledby="nav-tab1"
                v-if="tab==1"
              >
                <div id="course-details">
                    <div class="group" v-for="(c, k) in product.content" :key="c" v-bind:class='{"active": showDetail(k), "last": lastItem(k)}'>
                        <div class="course-chapter-title" v-on:click="toggleDetail(k)">
                          <div class="icon">
                            <i class="far fa-chalkboard-teacher"></i>
                          </div>
                            <div class="text">
                                {{ c.title }}
                            </div>
                            <div class="icon">
                                <i class="fal fa-chevron-down"></i>
                            </div>
                        </div>
                        <div class="details">
                            <div v-for="d in c.details" :key="d">
                            {{ d.v }}
                            </div>
                        </div>

                    </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </PublicView>
</template>
<style lang="less">
#course-details {
  padding: 0 30px;
    .group {
      margin-bottom: 20px;
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
      transition: 1s box-shadow;
        .course-chapter-title {
            padding: 10px;
            font-weight:  bold;
            color: #263787;
            cursor: pointer;
            display: flex;
            box-shadow: none;
            transition: 1s box-shadow;
            .text {
                flex: 1;
                padding-left: 20px;
                line-height: 45px;
                font-size: 18px;
            }
            .icon {
                width: 40px;
                line-height: 45px;
            }
            .icon:first-of-type {
                width: 45px;
                height: 45px;
                line-height: 45px;
                border-radius: 8px;
                background: #2db7ff;
                text-align: center;
                color: #fff;
            }
            .icon:last-of-type {
              i {
                transition: 1s transform;
              }
            }
        }
        .details {
            overflow-y: hidden;
            max-height: 0;
            border: none;
            padding: 0 15px;
            transition: 1s max-height, 1s padding, 1s border;
        }
        &.active {
          box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2);
            .details {
                max-height: 1000px;
                padding: 15px;
            }
            .course-chapter-title {
              box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
              color: #2db7ff;
              .icon:last-of-type {
                i {
                  font-weight: bold;
                  transform: rotate(180deg);
                }
              }
            }
            &.last {
                .course-chapter-title {
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                }
            .details {
                    max-height: 1000px;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;
            }

            }
        }
        &:first-of-type {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        .course-chapter-title {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;

        }
        }
        &:last-of-type {
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
            .course-chapter-title {
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
            }
        }
    }

}
.flexslider-thumbnails {
  .swiper {
    .swiper-wrapper {
      .swiper-slide {
        width: 80px;
      }
    }
  }
}
.single-item-desc {
  p:empty {
    height: 1.5em;
  }
}
.single-item-content {
  .colors {
    display: flex;
    column-gap: 8px;
    .color {
      height: 25px;
      width: 25px;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      &.select {
        border: 2px solid #2db7ff;
      }
      .line {
        height: 25px;
        width: 2px;
        transform: rotate(45deg);
      }
    }
  }
}
</style>
<script>
import PublicView from "@/components/PublicView.vue";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import {toRaw} from "vue";
// Import Swiper styles
import "swiper/css";

import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
export default {
  data() {
    return {
      previewImg: "",
      material: null,
      color: null,
      tab: 0,
      xShowDetail: {}
    };
  },
  methods: {
    lastItem(key) {
        if(this.product && this.product.content) {
            return key == this.product.content.length - 1;
        }
        return false;
    },
    toggleDetail(c) {
        console.log(c);
        this.xShowDetail[toRaw(c)] = !this.xShowDetail[toRaw(c)];
    },
    showDetail(c) {
        return this.xShowDetail[toRaw(c)];
    },
    selectColor(c) {
      this.color = c.name;
    },
    selectMaterial(m) {
      this.material = m;
      if (this.color) {
        let colorCheck = this.material.colors.find((i) => i.name == this.color);
        if (!colorCheck) {
          this.color = null;
        }
      }
    },
    styleColor(c) {
      return "background: " + c;
    },
    productLink(id, alias) {
      return "/san-pham/" + alias + "/" + id;
    },
    numberFormat(num) {
      return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(num);
    },
  },
  mounted() {
    console.log(this.product);
    if (
      this.product &&
      Array.isArray(this.product.images) &&
      this.product.images.length > 0
    ) {
      this.previewImg = this.product.images[0];
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    PublicView,
  },
  computed: {
    materialImg() {
      let colorCheck = this.material.colors.find((i) => i.name == this.color);
      if (colorCheck) {
        return colorCheck.images;
      } else {
        return [];
      }
    },
    price() {
      if (this.product) {
        if (this.material) {
          return this.product.price + this.material.addPrice;
        } else {
          return this.product.price;
        }
      } else {
        return -1;
      }
    },
    colors() {
      if (this.material) {
        return this.material.colors;
      }
      if (this.product && this.product.productOption) {
        return this.product.productOption.colors;
      } else {
        return [];
      }
    },
    product() {
      let product = this.$store.getters.product(this.$route.params.id);
      if (product) {
        document.querySelector("title").innerText =
          "Azzura.vn - " + product.seoData.title;
      }
      return product;
    },
  },
  watch: {
    product(v) {
      if (v && Array.isArray(v.images) && v.images.length > 0) {
        this.previewImg = v.images[0];
      }
    },
  },
  setup() {
    const setThumbsSwiper = (swiper) => {
      console.log(swiper);
    };

    return {
      setThumbsSwiper,
      modules: [FreeMode, Navigation, Thumbs],
    };
  },
};
</script>